export default {
getSchoolInfo(state){
    return state.schoolInfo
}
}
